import axios from 'axios'
import store from '../store'
import {DEFAULT_ERROR_MESSAGE} from "../helpers/Constants";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

function createApiClient() {
    let apiClient = axios.create({
        baseURL: '/sl/api',
        //timeout: 100000,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
    })
    apiClient.interceptors.request.use(function (config) {
        if (config.showBusy == undefined || config.showBusy) {
            store.commit('setBusy', true)
        }
        const loginToken = sessionStorage.getItem('loginToken')
        if (loginToken) {
            config.headers['X-Login-Token'] = loginToken;
        }
        const landerToken = sessionStorage.getItem('landerToken')
        if (landerToken) {
            config.headers['X-Lander-Token'] = landerToken;
        }
        const authToken = localStorage.getItem('authToken')
        if (authToken) {
            config.headers.Authorization = 'Bearer ' + authToken
        }
        config.headers.Accept = 'application/json'

        return config
    });
    apiClient.interceptors.response.use(function(response) {
        if (response?.config?.showBusy == undefined || response?.config?.showBusy) {
            store.commit('setBusy', false);
        }
        return response
    }, function (err) {
        if (err?.config?.showBusy == undefined || err?.config?.showBusy) {
            store.commit('setBusy', false)
        }
        return { data: { success: false, errorMsg: DEFAULT_ERROR_MESSAGE, errorCode: 9002 } }
    });
    return apiClient;
}

const apiClient = createApiClient()

export default {

    async getLanderDetails(data) {
        return await apiClient.post(store.getters.landerApiUrl ?? '/lander', data, {});
    },

    async saveProspect(prospect) {
        return await apiClient.post('/prospect', prospect, {showBusy: false});
    },

    async payAndSubscribe(data) {
        return await apiClient.post('/subscribe', data);
    },

    async getConvergeSessionToken() {
        return await apiClient.post('/cvgtoken', null,{showBusy: false});
    },
    async loadCaptcha() {
        return await apiClient.get('/captcha/flat', {showBusy: false});
    },

    async getUserProductSummary(product, tp) {
        return await apiClient.get('/summary/' + product, {params: { tp } });
    },

    async subscribeUpsell(data) {
        return await apiClient.post(store.getters.upsellActionUrl ?? '/ups', data);
    },

    async logElk(data) {
        return await apiClient.post('/elk', data, {showBusy: data.showBusy ?? false });
    },
    async getTrustPilotData() {
        return await apiClient.get('/trustpilot');
    },

    async optOutOffline(data) {
        return await apiClient.post('/optoutoffline', data);
    },

    async sendMobileVerificationCode(data) {
        console.log(data)
        return await apiClient.post('/send-mobile-verification-code', data);
    },
    async validateMobileVerificationCode(data) {
        return await apiClient.post('/validate-mobile-verification-code', data);
    },
}


